module.exports = __webpack_public_path__ + "static/logo_VSE-dfcd0b95e3a398887b82eef09e1c57dc.png";